export const ADD_INVENTORY_RECEIPT_MODAL_TITLE = 'Add inventory receipt';
export const SAVE_BUTTON_LABEL = 'Save changes';
export const CANCEL_BUTTON_LABEL = 'Cancel';
